interface EdgeGlobeNode {
  readonly id: string;
  readonly location: readonly [number, number];
}

interface EdgeGlobeRoute {
  readonly from: string;
  readonly to: string;
  readonly duration: number;
  readonly delay: number;
}

export const EDGE_GLOBE_NODES: readonly EdgeGlobeNode[] = [
  { id: "deploy", location: [38.72, -9.14] },
  { id: "sf", location: [40.78, -122.42] },
  { id: "ny", location: [40.71, -74.01] },
  { id: "sao", location: [1, -66.9] },
  { id: "tokyo", location: [43, 95] },
  { id: "singapore", location: [1.35, 103.82] },
  { id: "sydney", location: [-33.87, 151.21] },
  { id: "cape", location: [-33.92, 18.42] },
];

export const EDGE_GLOBE_ROUTES: readonly EdgeGlobeRoute[] = [
  { from: "deploy", to: "sf", duration: 3.2, delay: 0 },
  { from: "deploy", to: "ny", duration: 2.8, delay: 0.45 },
  { from: "deploy", to: "sao", duration: 3.4, delay: 0.9 },
  { from: "deploy", to: "tokyo", duration: 4, delay: 1.35 },
  { from: "deploy", to: "singapore", duration: 3.6, delay: 1.8 },
  { from: "deploy", to: "sydney", duration: 4.2, delay: 2.25 },
  { from: "deploy", to: "cape", duration: 3, delay: 2.7 },
];
